import React from "react";
import Careers from "@/components/careers/Careers";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Careers",
};

const CareersScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Careers />
    </>
  );
};

export default CareersScreen;
